const ATTR_KEYS = ["gclid", "gbraid", "wbraid", "fbclid", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

const GTM_ID = process.env.REACT_APP_GTM_ID;
const GA4_ID = process.env.REACT_APP_GA4_ID;
const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

const ADS_LABELS = {
  live_chat_started: process.env.REACT_APP_ADS_LABEL_LIVE_CHAT_STARTED,
  qualified_chat: process.env.REACT_APP_ADS_LABEL_QUALIFIED_CHAT,
  whatsapp_handoff: process.env.REACT_APP_ADS_LABEL_WHATSAPP_HANDOFF,
};

export function initTracking() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];

  const params = new URLSearchParams(window.location.search);
  const stored = JSON.parse(sessionStorage.getItem("tks_attr") || "{}");
  const attr = { ...stored };
  ATTR_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) attr[k] = v;
  });
  sessionStorage.setItem("tks_attr", JSON.stringify(attr));

  // Single owner rule: if GTM is present it owns all Google tags.
  if (GTM_ID) {
    if (!document.querySelector('script[src*="googletagmanager.com/gtm.js"]')) {
      window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(s);
    }
  } else if (GA4_ID || ADS_ID) {
    window.gtag =
      window.gtag ||
      function () {
        window.dataLayer.push(arguments);
      };
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA4_ID || ADS_ID)}`;
    document.head.appendChild(s);
    window.gtag("js", new Date());
    if (GA4_ID) window.gtag("config", GA4_ID, { send_page_view: false });
    if (ADS_ID) window.gtag("config", ADS_ID);
  }

  let fired50 = false;
  let fired90 = false;
  const onScroll = () => {
    const doc = document.documentElement;
    const max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    const pct = (window.scrollY / max) * 100;
    if (!fired50 && pct >= 50) {
      fired50 = true;
      trackEvent("scroll_50");
    }
    if (!fired90 && pct >= 90) {
      fired90 = true;
      trackEvent("scroll_90");
    }
  };
  window.addEventListener("scroll", onScroll, { passive: true });
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem("tks_attr") || "{}");
  } catch {
    return {};
  }
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, ...getAttribution(), ...params });
}

const seenConversions = new Set();

export function trackConversion(name, params = {}) {
  if (typeof window === "undefined") return;
  const eventId = params.event_id || `${name}:${window.location.pathname}:${Date.now()}`;
  if (seenConversions.has(eventId)) return;
  seenConversions.add(eventId);

  // Always push to dataLayer (GTM Custom Event triggers depend on it; also
  // keeps events visible for debugging before IDs are configured).
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: name, event_id: eventId, ...getAttribution(), ...params });
  if (GTM_ID) return;
  if (GA4_ID && window.gtag) {
    window.gtag("event", name, { ...params, event_id: eventId });
  }
  const label = ADS_LABELS[name];
  if (ADS_ID && label && window.gtag) {
    window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}`, event_id: eventId });
  }
}

export function trackPageView(path) {
  if (!GA4_ID || GTM_ID || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_location: window.location.href,
    page_path: path,
    page_title: document.title,
  });
}
